export function SuggestionChips({
  suggestions,
  onSelect,
}: {
  suggestions: string[]
  onSelect: (question: string) => void
}) {
  if (!suggestions.length) return null

  return (
    <div className="mt-3.5 flex flex-wrap gap-1.5">
      {suggestions.map((question, i) => (
        <button
          key={question}
          type="button"
          onClick={() => onSelect(question)}
          className="animate-in fade-in slide-in-from-bottom-1 fill-mode-both rounded-full border border-border bg-card px-3.5 py-1.5 text-left text-xs text-fg2 transition-colors duration-200 hover:border-orange/50 hover:bg-hover hover:text-foreground"
          style={{ animationDelay: `${i * 60}ms` }}
        >
          {question}
        </button>
      ))}
    </div>
  )
}
